module.exports = "https://99designs-start-assets.imgix.net/js/5bfdac284babe4cee91fd1165949656d.png";